// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Knowledge Base subsystem registration.
 */
import { registerSubsystem } from '../../core/layout-registry'
import { KnowledgeBaseUserViewWrapper } from './shared/components/UserViewWrapper'
import { KnowledgeBaseAdminView } from './shared/components/AdminView'

registerSubsystem({
  id: 'knowledge-base',
  name: 'Knowledge Base',
  description: 'Knowledge base for analysis guidance',
  components: [
    {
      id: 'knowledge_base',
      label: 'Knowledge Base',
      icon: 'BookOpen',
      category: 'knowledge-base',
      description: 'Define guidance items to inject into analysis prompts',
      order: 20,
      Component: KnowledgeBaseUserViewWrapper,
      ConfigComponent: KnowledgeBaseAdminView,
    },
  ],
})